export interface EngagementSystem {
  readonly domainLoaded: boolean;
}

export const initialEngagementSystem: EngagementSystem = {
  domainLoaded: false,
};
